const LISTED = 'listed';
const VALIDATED = 'validated';
const INSERTED = 'inserted';

const chipTypes = {
    LISTED,
    VALIDATED,
    INSERTED,
};

export default chipTypes;
